import { render, staticRenderFns } from "./ProductListSearchMenu.vue?vue&type=template&id=6000f21e&"
import script from "./ProductListSearchMenu.vue?vue&type=script&lang=ts&"
export * from "./ProductListSearchMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports